// True when a server-side multi-select group has been fully emptied by the user, meaning the
// board/rail must show nothing. The backend treats an empty list as "no filter" (shows everything)
// for these three groups, so the frontend short-circuits to an empty result itself.
// A group only counts as "emptied" once its options have loaded (the length check), so this does
// not fire before fetchUsers/fetchLabels/fetchStatuses populate the defaults.
export const hasEmptiedServerFilterGroup = ({
  users = [],
  selectedUsers = [],
  labels = [],
  selectedLabels = [],
  statuses = [],
  selectedStatuses = [],
} = {}) =>
  (users.length > 0 && selectedUsers.length === 0) ||
  (labels.length > 0 && selectedLabels.length === 0) ||
  (statuses.length > 0 && selectedStatuses.length === 0);
